import { gql } from '@apollo/client';

export const GET_DATA = gql`
    query userTodoos($user_id: String!) {
      getTodos(user_id: $user_id) {
        dateTimeToDoToDo
        title
        description
        listName
        isDone
        percentDone
        order
        id
        notes {
            createdDate
            updatedDate
            note
            title
        }
        dateDone_utc
      }
    }`;

    export const GET_SUGGESTED_STEPS = gql`
    query suggestSteps($user_id: String!, $todo_id: String!) {
      suggestSteps(user_id: $user_id, todo_id: $user_id) {
        commentary
        steps
      }
    }`;

export const GET_TODOS_AND_CATEGORIES = gql`
query GetTodosAndCategories($user_id: String!) {
  getTodosAndCategories(user_id: $user_id) {
    todos {
        dateTimeToDoToDo
        title
        description
        listName
        isDone
        percentDone
        order
        id
        steps {
          step
        }
        notes {
            createdDate
            updatedDate
            note
            title
        }
        dateDone_utc
        responders {
          userId
          email
          name
          role
        }
        conversation {
          messageId
          message
          authorUserId
          authorName
          authorRole
          timestamp
          isRead
        }
        contactMetadata {
          submittedDate
          customerResolved
          adminResolved
          lastViewedByCustomer
          lastViewedByAdmin
        }
        isAdminTodo
        isAdminContactTodo
    }
    categories{
      listName
    }
}
}`;
    
export const CREATE_TODO = gql`
  mutation createTodo($input: TodoInput!) {
    createTodo(input: $input) {
      title
      description
      listName
      dateTimeToDoToDo
      notes {
          createdDate
          updatedDate
          note
          title
      }
      isDone
      percentDone
      order
    }
  }
`;

export const UPDATE_TODO = gql`
  mutation updateTodo( $id: String!, $input: TodoInput!) {
    updateTodo(
        id:$id, 
        input: $input
    ) {
      dateTimeToDoToDo
      title
      description
      listName
      percentDone
      id
      user_id
      notes {
        createdDate
        updatedDate
        note
        title
      }
    }
  }
`;


export const ASSISTANT_RESPONSE = gql`
  mutation CreateAssistantResponse($input: AssistantInput!){
    createAssistantResponse(input: $input) {
      response
    }
  }
`;

export const DELETE_TODO = gql`
  mutation deleteTodo($id: String!, $user_id: String!) {
    deleteTodo(id: $id, user_id: $user_id) 
  }
`;

export const REORDER_TODO = gql`
    mutation reorderTodo($id: String!, $user_id: String, $increment: Int) {
        reorderTodo(id: $id, user_id: $user_id, increment: $increment)
    }
`;

export const MARK_DONE = gql`
    mutation markDone( $user_id: String , $id: String!) {
        markDone( user_id: $user_id, id: $id)
    }
`;

export const MARK_NOT_DONE = gql`
    mutation markNotDone( $user_id: String , $id: String!) {
        markNotDone(user_id: $user_id, id: $id)
    }
`;

// Contact Todo Tracking / Conversation Queries
export const GET_UNREAD_COUNT = gql`
    query getUnreadCount($user_id: String!, $todo_id: String!) {
        getUnreadCount(user_id: $user_id, todo_id: $todo_id) {
            id
            unreadCount
        }
    }
`;

export const GET_TODOS_WITH_UNREAD = gql`
    query getTodosWithUnread($user_id: String!) {
        getTodosWithUnread(user_id: $user_id) {
            id
            title
            listName
            unreadCount
        }
    }
`;

// Contact Todo Tracking / Conversation Mutations
export const ADD_CONVERSATION_MESSAGE = gql`
    mutation addConversationMessage($user_id: String!, $todo_id: String!, $message: String!) {
        addConversationMessage(user_id: $user_id, todo_id: $todo_id, message: $message) {
            id
            message
            messageId
        }
    }
`;

export const MARK_CONVERSATION_READ = gql`
    mutation markConversationRead($user_id: String!, $todo_id: String!) {
        markConversationRead(user_id: $user_id, todo_id: $todo_id) {
            id
            message
        }
    }
`;

export const UPDATE_CONTACT_METADATA = gql`
    mutation updateContactMetadata($user_id: String!, $todo_id: String!, $metadata: ContactMetadataInput!) {
        updateContactMetadata(user_id: $user_id, todo_id: $todo_id, metadata: $metadata) {
            id
            message
        }
    }
`;
